import { CloseOutlined } from "@mui/icons-material";
import { CircularProgress, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { apiGatewayAxiosInstance } from "../../../../utils/axios";
import { useEffect } from "react";

export default function TestTemplateModel({ open, setOpen, templateData, setErrorResponse, operationStatus, setOperationStatus, botDetails }) {
    const state = useSelector(state => state.campaignManagmentSlice);
    const dispatch = useDispatch();
    const [variableValues, setVariableValues] = useState({});
    const [isVariables, setIsVariables] = useState({
        state: false,
        data: []
    });
    const [isLoading, setIsLoading] = useState(false);

    const [variableAdded, setVariableAdded] = useState(false);
    const [selectedTestNumber, setSelectedTestNumber] = useState();

    const botId = templateData?.botId;
    const templateId = templateData?._id;

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setVariableValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));

        setVariableValues({ ...variableValues, [name]: value })
    };

    const handleSelectChange = (event) => {
        setSelectedTestNumber(event.target.value);
    };

    const sendTestMessage = async (botId, templateId, number, variables) => {
        try {
            const body = {
                botId,
                templateId,
                number,
                variables
            }
            setIsLoading(true);
            const response = await apiGatewayAxiosInstance.post(`/bot_management/test-device/send-test-message`, body);
            if (response.status === 200) {
                setIsLoading(false);
                setOperationStatus({ success: true, failed: false, message: "Test Message Sent Successfully" });

                handleClose();

            } else {
                setIsLoading(false);
                setErrorResponse("Message not send!");
            }
            return response;
        } catch (error) {
            setIsLoading(false);
            let errorMessage = "Server not reachable.";
            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setErrorResponse(errorMessage);
        }
    }

    const handleSendTestMessage = async (templateId) => {
        try {
            if (templateData?.variables && templateData?.variables.length > 0) {
                const variables = templateData?.variables;
                setIsVariables({ state: true, data: variables });
                setVariableAdded(true);
            }
        } catch (error) {
            console.error('Error in getTemplateVariablesByTemplateId:', error);
            throw error;
        }
    };

    useEffect(() => {
        handleSendTestMessage(templateData);
    }, []);

    return (
        <Dialog open={open} onClose={handleClose} sx={{ padding: "1rem" }} fullWidth maxWidth={"xs"}>
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant='h5'>Test Template</Typography>
                <IconButton onClick={() => handleClose()}>
                    <CloseOutlined />
                </IconButton>
            </DialogTitle>
            <Divider variant='middle' />
            <DialogContent>
                <Grid mt={3} sx={{ display: "flex", alignItems: "center", width: "100%" }}  >
                    {(!botDetails?.botName || botDetails?.testDevices?.length > 0) ?
                        (
                            <FormControl fullWidth >
                                <InputLabel id="select-template-label">
                                    Select Number
                                </InputLabel>
                                <Select
                                    fullWidth
                                    label=" Select Number"
                                    labelId="select-template-label"
                                    id="select-template-label"
                                    value={selectedTestNumber}
                                    onChange={handleSelectChange}
                                >
                                    {botDetails?.testDevices?.length > 0 &&
                                        botDetails?.testDevices.map((testDevice, index) => (
                                            <MenuItem value={testDevice} >
                                                {testDevice}
                                            </MenuItem>
                                        )
                                        )
                                    }
                                </Select>
                            </FormControl>
                        ) : (
                            <FormControl sx={{ width: "100%" }} >
                                <Select
                                    fullWidth
                                    disabled
                                    value={"No Test Devices for this Bot"}
                                >
                                    <MenuItem value={"No Test Devices for this Bot"}>
                                        <Typography variant="h5">
                                            No Test Devices for this Bot
                                        </Typography>
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        )}
                </Grid>
                {
                    isVariables.state &&
                    <Grid>
                        <Typography mt={5} id="variables-modal-title" variant="h6" component="h2" gutterBottom>
                            Enter Variable Values
                        </Typography>
                        {isVariables.data && isVariables.data.length > 0 ? (
                            isVariables.data.map((variable, index) => (
                                <TextField
                                    key={index}
                                    fullWidth
                                    name={variable}
                                    label={variable}
                                    value={variableValues[variable] || ''}
                                    onChange={handleChange}
                                    margin="normal"
                                />
                            ))
                        ) : (
                            <Typography>No variables to display</Typography>
                        )}
                    </Grid>
                }
            </DialogContent>
            <DialogActions
                style={{
                    padding: "1rem 1.5rem",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: ".25rem",
                }}
            >
                <Button variant='outlined' color="error" onClick={handleClose}>
                    Cancel
                </Button>
                <Grid>
                    {
                        isLoading ? (
                            <Button variant='outlined'>
                                <CircularProgress size={20} className='spinner' />
                                Sending Message...
                            </Button>
                        ) :
                            <Button variant="outlined" className="m-2" disabled={!selectedTestNumber} onClick={() => { sendTestMessage(botId, templateId, selectedTestNumber, variableValues) }}>
                                Send Test Message
                            </Button>
                    }
                </Grid>
            </DialogActions>
        </Dialog>
    );
}
